import { mount } from "svelte";
import "./app.css";
import App from "./App.svelte";
import { hideAppLoadingDirect, isEmbedded } from "../libs/chief-bridge";
import { reloadStorageModel } from "../libs/storage-manager";

// 标记内嵌环境，供 CSS 使用
if (isEmbedded()) {
  document.documentElement.classList.add("embedded");
}

reloadStorageModel(50).then(async () => {
  await import("./i18n");
  await import("./theme");

  const app = mount(App, {
    target: document.getElementById("app")!,
  });

  hideAppLoadingDirect();
}).catch((err) => {
  console.error("App initialization failed:", err);
  hideAppLoadingDirect();
});
